import { LightningElement, api } from "lwc";
import { assignedElements } from "common/slot";
import { getNextFocusIndex } from "common/a11y";

let uid = 0;
class radioGroup extends LightningElement {
  @api value = "";
  @api label = null;
  uid = uid++;
  focusedIndex = 0;
  inputs = [];
  connectedCallback() {
    this.addEventListener("keydown", this.handleKeydown);
  }
  disconnectedCallback() {
    this.removeEventListener("keydown", this.handleKeydown);
  }
  handleSlotChange(e) {
    const slot = e.target;
    this.inputs = assignedElements(slot).filter((el) => {
      return (
        el.nodeName.includes("TDS-INPUT") ||
        el.classList.contains("radio-group-item")
      );
    });
    this.inputs.forEach((i) => {
      i.removeEventListener("change", this.handleChange);
      i.addEventListener("change", this.handleChange);
      i.removeEventListener("focus", this.handleFocus);
      i.addEventListener("focus", this.handleFocus);
    });
    this.inputs.forEach((i) => {
      i.setAttribute("name", `group-${this.uid}`);
    });
    this.updateChecked();
  }
  updateChecked() {
    this.inputs.forEach((i) => {
      i.checked = String(i.value === this.value);
      i.setAttribute("checked", String(i.value === this.value));
    });
  }
  handleKeydown = (e) => {
    switch (e.code) {
      case "ArrowUp":
      case "ArrowLeft": {
        e.preventDefault();
        const i = getNextFocusIndex(
          "prev",
          this.focusedIndex,
          this.inputs.length
        );
        this.inputs[i].focus();
        this.focusedIndex = i;
        break;
      }
      case "ArrowDown":
      case "ArrowRight": {
        e.preventDefault();
        const i = getNextFocusIndex(
          "next",
          this.focusedIndex,
          this.inputs.length
        );
        this.inputs[i].focus();
        this.focusedIndex = i;
        break;
      }
    }
  };
  handleFocus = (e) => {
    this.focusedIndex = this.inputs.findIndex(
      (i) => i.value === e.target.value
    );
  };
  handleChange = (e) => {
    const target = e.currentTarget;
    this.value = target.value;
    this.updateChecked();
    this.dispatchEvent(
      new CustomEvent("change", {
        detail: this.value,
      })
    );
  };
}

export default radioGroup;
